<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t("CampaignEdit.Phones.DefaultClientPhoneDlg.Title", { CLIENT_TITLE: clentTitle }) }}</p>
      <button
          type="button"
          class="delete"
          @click="close()"/>
    </header>
    <section class="modal-card-body">
      <b-field :label="$t('CampaignEdit.Phones.DefaultClientPhoneDlg.DefaultPhone')">
        <b-input type="textarea" v-model="phone" placeholder="XXX-XXXXXXX"></b-input>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <b-button :label="$t('Save')" type="is-primary" @click="update()" />
      <b-button :label="$t('Cancel')" @click="close()" />
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class DefaultClientPhoneDlg extends Vue {
  @Prop() readonly clentTitle!: string;
  
  phone = "";

  close() {
    this.$emit("close");
  }

  update() {
    this.$emit("update", this.phone);
  }
}
</script>
